import { render, staticRenderFns } from "./receipt-image-information.vue?vue&type=template&id=69896f0b&scoped=true"
import script from "./receipt-image-information.vue?vue&type=script&lang=js"
export * from "./receipt-image-information.vue?vue&type=script&lang=js"
import style0 from "./receipt-image-information.vue?vue&type=style&index=0&id=69896f0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69896f0b",
  null
  
)

export default component.exports